import { toFiniteNumber } from "./numbers";
export const normalizeWeeklyPodium = (raw) => {
    if (!Array.isArray(raw))
        return [];
    return raw.map((student) => ({
        student_id: toFiniteNumber(student?.student_id),
        name: student?.name ?? '',
        weekly_hours: toFiniteNumber(student?.weekly_hours),
        xp: toFiniteNumber(student?.xp),
        position: toFiniteNumber(student?.position),
        avatar: student?.avatar
    }));
};
export const normalizeStudentCompetitor = (raw) => {
    if (!raw)
        return null;
    return {
        student_position: toFiniteNumber(raw.student_position),
        competitor: raw.competitor ?? null,
        is_first_place: Boolean(raw.is_first_place),
        weekly_hours: toFiniteNumber(raw.weekly_hours),
        hours_ahead: raw.hours_ahead,
        hours_remaining: raw.hours_remaining
    };
};
